import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';
import { initialsOf } from '../data/instructors';

interface AvatarProps {
  name: string;
  /** Color de fondo del círculo. */
  bg?: string;
  /** Diámetro en píxeles. */
  size?: number;
}

const Circle = styled.div<{ bg: string; size: number }>(({ bg, size }) => ({
  width: size,
  height: size,
  flex: 'none',
  borderRadius: '50%',
  background: bg,
  color: t.color.surface,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: t.font,
  fontSize: size <= 40 ? 14 : 20,
  fontWeight: 600,
}));

/**
 * Primitivo: avatar circular con las iniciales del nombre.
 * Si el nombre está vacío muestra un "+", útil en el formulario de alta.
 */
const Avatar = ({ name, bg = t.color.segmentTrack, size = 40 }: AvatarProps) => (
  <Circle bg={bg} size={size}>
    {name.trim() ? initialsOf(name) : '+'}
  </Circle>
);

export default Avatar;
